/**
 * Get the admin user from the full name
 * @param {string} fullName - The full name of the user (concatenation of firstname and lastname).
 * @param {User[]} admins - The list of admin users.
 * @returns {User} - The admin user.
 */
export const getAdminUserFromName = (fullName, admins) => admins.find((admin) => fullName === `${admin.firstname} ${admin.lastname}`);

/**
 * Format a person's full name from first and last name parts.
 * @param {object} [person] - Person object.
 * @param {string} [person.firstname] - First name.
 * @param {string} [person.lastname] - Last name.
 * @returns {string}
 */
export const formatPersonFullName = ({ firstname, lastname } = {}) => `${firstname || ''} ${lastname || ''}`.trim();
